import * as React from "react";
import { forwardRef } from "react";
const SvgLoadingSpinner = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 100 100", preserveAspectRatio: "xMidYMid", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("circle", { cx: 50, cy: 50, fill: "none", stroke: "currentColor", strokeWidth: 8, r: 35, strokeDasharray: "164.93361431346415 56.97787143782138" }, /* @__PURE__ */ React.createElement("animateTransform", { attributeName: "transform", type: "rotate", repeatCount: "indefinite", dur: "1s", values: "0 50 50;360 50 50", keyTimes: "0;1" })));
const ForwardRef = forwardRef(SvgLoadingSpinner);
export default ForwardRef;
